import { Dispatch } from "redux";
import { IFlyerRuntimePageSpotItem } from "../../dtos/flyer";
import { TToggleDetailsActions } from "../actions/detailsActions";

export function toggleDetailsAction(payload?: IFlyerRuntimePageSpotItem) {
    return async (dispatch: Dispatch<TToggleDetailsActions>) => {
        dispatch({
            type: "TOGGLE_DETAILS",
            payload,
        })
    };
}